// extracted by mini-css-extract-plugin
export default {"menu":"menu-Pr02J","divider":"divider-MzR1j"};